export const CURRENT_CONFIG = {

  // license
  appId: '128771', // You need to go to the development website to apply.
  appKey: 'a468de502f78bda84400b7d4a7f3376', // You need to go to the development website to apply.
  appLicense: 'nnEuzO0MA2sFMJOwiYa5DUk1jaEslYJa5F889R0Ds9KgsNZzB20LQ5FlECxT0nqi8Q8XbrWx4w6+BaoiO+fkzr+HA5Fb38dqZnt5WhtUO5AkTO3bLLY1rM9LCzuqnTGgfmrEzaI5DaxKnrvIO6X9pY7LDUT3XZY7EY0mrzitqMw=', // You need to go to the development website to apply.

  // http
  baseURL: import.meta.env.VITE_APP_APIGATEWAY_HTTP_ENDPOINT, // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: import.meta.env.VITE_APP_APIGATEWAY_WS_ENDPOINT, // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: '22df707490e7631397c9fbb02e52544e',

}
